module.exports = __webpack_public_path__ + "media/stylesheets/images/media/userway_function_icons/icn-feature-10-274212a0a45c9ba7538da334e7f7c0a6.svg";